export const SITE_URL = "https://eradikbreizh.fr";
export const CALENDLY_URL = "https://calendly.com/eradikbreizh/nuisibles";
